<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Países</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Países</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">{{ labelInitials }}</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(country, index) in countries" :key="index">
                    <td></td>
                    <td class="text-left">{{ country.Name }}</td>
                    <td>
                      {{
                        country.Initials == undefined ||
                        country.Initials == "" ||
                        country.Initials == null
                          ? "-"
                          : country.Initials
                      }}
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('Country', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenCountry($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Country', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenCountry($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('Country', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ConfirmDeleteCountry(country.Name, country.Id)
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      countries == undefined ||
                      countries == null ||
                      countries.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="sm"
      id="mFormCountry"
      :title="modalTitle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Description -->
        <ValidationObserver tag="form" ref="validatedCountryForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>País</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoCountries.Name"
                  :class="validatedCountryForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCountryForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Initials -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>{{ labelInitials }}</label>
              <ValidationProvider
                rules="required|min:2"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  v-model="infoCountries.Initials"
                  :class="validatedCountryForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCountryForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveCountry()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="País"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelInitials"
            type="text"
            class="form-control"
            v-model="filter.Initials"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Country', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo país"
      v-on:click="OpenCountry($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "countries",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      labelName: "País",
      labelInitials: "Sigla",
      modalTitle: "Novo País",
      countFilter: 0,
      filter: {
        Name: null,
        Initials: null,
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      idCountry: 0,
      pOpened: null,
      countries: [],
      infoCountries: {
        Name: null,
        Initials: null,
      },
      isSeeing: false,
      validatedCountryForm: false,
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListCountry();
    },
    "pagination.RowsPerPage": function () {
      this.ListCountry();
    },
  },
  mounted() {
    this.ListCountry();
  },
  methods: {
    OpenCountry: function (e, i, view) {
      e.preventDefault();
      this.validatedCountryForm = false;
      this.ResetInfoCountry();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idCountry = this.countries[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar País";
        this.GetCountry();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.ResetInfoCountry;
        this.isSeeing = false;
        this.modalTitle = "Novo País";
        this.ResetInfoCountry();
      } else {
        // View
        this.pOpened = i;
        this.idCountry = this.countries[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do País";
        this.GetCountry();
      }
      this.$bvModal.show("mFormCountry");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListCountry();
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
      };
      this.ListCountry();
    },
    ResetInfoCountry: function () {
      this.infoCountries = {
        Name: null,
        Initials: null,
      };
    },
    SaveCountry: function () {
      this.validatedCountryForm = true;

      this.$refs.validatedCountryForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddCountry", this.infoCountries)
              .then(() => {
                this.$makeToast(
                  "O País foi cadastrado com sucesso.",
                  "success",
                  "País cadastrado"
                );
                this.ListCountry();
                this.$bvModal.hide("mFormCountry");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao cadastrar o País",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateCountry", this.infoCountries)
              .then(() => {
                this.$makeToast(
                  "O País foi atualizado com sucesso.",
                  "success",
                  "País atualizado"
                );
                this.ListCountry();
                this.$bvModal.hide("mFormCountry");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar o País",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetCountry: function () {
      if (this.idCountry != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetCountry", { id: this.idCountry })
          .then((response) => {
            this.infoCountries = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao carregar o País",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListCountry: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Initials)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Initials": this.filter.Initials,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("CountryList", { params: data })
        .then((response) => {
          this.countries = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os Países",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmDeleteCountry: function (description, id) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover " + description + " ?",
        "Confirmar",
        this.DeleteCountry,
        id
      );
    },
    DeleteCountry: function (id) {
      this.$store
        .dispatch("DeleteCountry", { id: id })
        .then(() => {
          this.$makeToast(
            "O Páis foi removido com sucesso.",
            "success",
            "País removido"
          );
          this.ListCountry();
          this.$bvModal.hide("mFormCountry");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao remover o País", error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/countries.vue